// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__xO5s7","summary":"CartItem_summary__x3MlX","price":"CartItem_price__8IW9f","amount":"CartItem_amount__UUwDR","actions":"CartItem_actions__jEJs9"};